module.exports = __webpack_public_path__ + "static/media/11 Storms Are On The Ocean.51ab5cc2.mp3";